














































































import { computed, defineComponent, ref, watch } from "@vue/composition-api";

import store from "@/store/root";
import { Match, Evidence } from "@/types";
import AuthPanel from "@/components/AuthPanel.vue";
import ModeButton from "@/components/ModeButton.vue";
import CodeDetails from "@/components/CodeDetails.vue";
import ComputedTime from "@/components/ComputedTime.vue";
import SinglePaneDocument from "@/components/SinglePaneDocument.vue";
import EvidencesList from "@/components/EvidencesList.vue";
import CodeForm from "@/components/CodeForm.vue";
import DocumentForm from "@/components/DocumentForm.vue";
import LiveCard from "@/tools/verify/components/LiveCard.vue";

export default defineComponent({
  components: {
    LiveCard,
    CodeDetails,
    AuthPanel,
    ComputedTime,
    ModeButton,
    SinglePaneDocument,
    EvidencesList,
    CodeForm,
    DocumentForm
  },
  setup() {
    const term = ref("");

    const selected = ref<[number, number] | null>(null);

    const evidence = computed(() => (store.state as any).evidences.list);

    const document = computed(() => store.state.text);

    const reset = () => store.dispatch("clear");

    const suggestedCodesInVerified = computed(() =>
      evidence.value
        .filter(e => e.type === "verified")
        .filter(e => e.pratio !== 0 && e.score !== 0)
        .map(e => e.better_matches)
        .flat(1)
    );

    const onEvidenceSelected = (match: Match | null) => {
      if (match) {
        this.term = "";
        this.selected = match.concept.text.tokpos;
        this.term = this.document
          .slice(...match.concept.text.charpos)
          .replace("\n", " ");
      }
    };

    const clearTermAndSelected = () => {
      term.value = "";
      selected.value = null;
    };

    return {
      term,
      selected,
      evidence,
      document,
      reset,
      suggestedCodesInVerified,
      onEvidenceSelected,
      clearTermAndSelected
    };
  }
});

// const Evidences = namespace("evidences");
//
// @Component({
//   components: {
//     LiveCard,
//     CodeDetails,
//     AuthPanel,
//     ComputedTime,
//     ModeButton,
//     SinglePaneDocument,
//     EvidencesList,
//     CodeForm,
//     DocumentForm
//   }
// })
// export default class VerifyView extends Vue {
//   private term: string = "";
//
//   private selected: [number, number] | null = null;
//
//   @Evidences.State("list")
//   private evidence!: Evidence[];
//
//   @State("text")
//   private document!: string;
//
//   @Action("clear")
//   reset!: () => void;
//
//   get suggestedCodesInVerified() {
//     return this.evidence
//       .filter(e => e.type === "verified")
//       .filter(e => e.pratio !== 0 && e.score !== 0)
//       .map(e => e.better_matches)
//       .flat(1);
//   }
//
//   onEvidenceSelected(match: Match) {
//     if (match) {
//       this.term = "";
//       this.selected = match.concept.text.tokpos;
//       this.term = this.document
//         .slice(...match.concept.text.charpos)
//         .replace("\n", " ");
//     }
//   }
//
//   clear() {
//     this.clearTermAndSelected();
//   }
//
//   clearTermAndSelected() {
//     this.term = "";
//     this.selected = null;
//   }
// }
